import styled from "styled-components";
import { COLORS, FONTS } from "../../../../../constants/Styles";

export const DescriptionText = styled.div`
  margin-top: 1rem;
  color: ${COLORS.secondaryLight};
`;

export const OptionsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
`;

export const StagedChangesContainer = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const StagedChangesHeader = styled.div`
  width: 100%;
  text-align: left;
  font-family: ${FONTS.spaceGrotesk};
`;

export const To = styled.span`
  color: ${COLORS.secondaryLight};
`;

export const StagedChangesList = styled.div`
  width: 100%;
  background-color: ${COLORS.tableBackground};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ChangeName = styled.div`
  color: ${COLORS.secondaryLight};
`;

export const ChangeDetail = styled.div`
  margin-top: 0.25rem;
`;
